export function getHeightOfHidden(element) {
    const el = element as HTMLElement;
    const parentStyles = el.parentElement.getAttribute('style');
    const selfStyles = el.getAttribute('style');
    el.parentElement.setAttribute('style', 'position: relative !important; width: 100% !important;');
    el.setAttribute('style', 'opacity: 0 !important; height: auto !important; position: absolute !important;');

    const elementHeight = element.offsetHeight;
    if (selfStyles) {
        el.setAttribute('style', selfStyles);
    }
    else {
        el.removeAttribute('style');
    }
    if (parentStyles) {
        el.parentElement.setAttribute('style', parentStyles);
    }
    else {
        el.parentElement.removeAttribute('style');
    }
    return elementHeight;
}

export function getWidthOfHidden(element) {
    const el = element as HTMLElement;
    const parentStyles = el.parentElement.getAttribute('style');
    const selfStyles = el.getAttribute('style');
    el.parentElement.setAttribute('style', 'position: relative !important; width: 100% !important;');
    el.setAttribute('style', 'opacity: 0 !important; height: auto !important; position: absolute !important;');

    const elementWidth = element.offsetWidth;
    if (selfStyles) {
        el.setAttribute('style', selfStyles);
    }
    else {
        el.removeAttribute('style');
    }
    if (parentStyles) {
        el.parentElement.setAttribute('style', parentStyles);
    }
    else {
        el.parentElement.removeAttribute('style');
    }
    return elementWidth;
}

export function getWidthOfHiddenWithInvisibleParent(element, invisibleParent?) {
    const invisibleParentStyles = invisibleParent ? invisibleParent.getAttribute('style') : '';
    if (invisibleParent) {
        invisibleParent.setAttribute('style', 'opacity: 0 !important; display: block !important; transition: none !important;');
    }
    element.parentElement.setAttribute('style', 'position: relative !important');
    element.setAttribute('style', 'opacity: 0 !important; height: auto !important; position: absolute !important;');
    const elementWidth: number = element.offsetWidth;
    element.removeAttribute('style');
    element.parentElement.removeAttribute('style');
    if (invisibleParent) {
        invisibleParent.setAttribute('style', invisibleParentStyles);
    }
    return elementWidth;
}